import React from "react";

/**
 * Context for passing data throughout application
 */
export const StateContext = React.createContext();
